import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";
import PublicLayout from "@/components/PublicLayout";
import Seo, { faqJsonLd } from "@/components/Seo";

export default function FAQPage() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(0);

    const QA = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => ({ q: t(`faq.q${n}`), a: t(`faq.a${n}`) }));

    return (
        <PublicLayout>
            <Seo
                title="Häufige Fragen zur KI-Bewerbung | Bewerbung24.ai"
                description="Antworten auf die häufigsten Fragen zu Bewerbung24.ai: Preise, Datenschutz, ATS-Optimierung, Sprachen und kostenloses Testen."
                path="/faq"
                jsonLd={faqJsonLd(QA)}
            />
            <section className="max-w-4xl mx-auto px-6 lg:px-8 pt-20 lg:pt-28 pb-12">
                <div className="h-1.5 w-16 rounded-full mb-7" style={{ background: "linear-gradient(35deg, #E7343F 0%, #F9B000 100%)" }} />
                <span className="eyebrow-warm">{t("faq.badge")}</span>
                <h1 className="font-heading mt-5 text-5xl sm:text-6xl lg:text-[5rem] font-bold tracking-tighter text-warm-strong leading-[0.95]">
                    {t("faq.h1Part1")}<br />
                    <span className="gradient-warm">{t("faq.h1Highlight")}</span>
                </h1>
            </section>

            <section className="max-w-3xl mx-auto px-6 lg:px-8 pb-24">
                <div className="space-y-2.5">
                    {QA.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <div
                                key={i}
                                className="rounded-2xl bg-white overflow-hidden transition-shadow hover:shadow-md"
                                style={{ borderLeft: `4px solid ${isOpen ? "#E7343F" : "#F9B000"}` }}
                                data-testid={`faq-item-${i}`}
                            >
                                <button
                                    onClick={() => setOpen(isOpen ? -1 : i)}
                                    className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-red-50/40 transition-colors"
                                    data-testid={`faq-toggle-${i}`}
                                >
                                    <span className="font-heading font-semibold text-warm-strong">{item.q}</span>
                                    <ChevronDown size={20} className={`text-warm-red transition-transform shrink-0 ml-3 ${isOpen ? "rotate-180" : ""}`} />
                                </button>
                                <div className={`px-6 pb-6 text-warm leading-relaxed border-t border-zinc-100 pt-4 ${isOpen ? "block" : "hidden"}`}>{item.a}</div>
                            </div>
                        );
                    })}
                </div>
            </section>
        </PublicLayout>
    );
}
